import {
  initialState,
  Actions,
  State,
  DELETE_REACTION,
  DELETE_REACTION_SUCCESS,
  DELETE_REACTION_ERROR,
  RESET_DELETE_REACTION,
} from "../../types/reaction/delete-reaction";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_REACTION:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_REACTION_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_REACTION_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_REACTION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
